/**
 * Member Directory API — 每個 avatar 一份會員名單
 *
 * Backend endpoints (qubby_backend_new):
 *   POST   /api/avatar/:avatarId/members
 *   GET    /api/avatar/:avatarId/members
 *   DELETE /api/avatar/:avatarId/members/:phone
 *
 * 給 IVR `lookup_member_by_phone` apiTool 查（內部走 /api/mock/members）
 */
import { api, get, del } from './client.js';

export async function fetchMembers(avatarId) {
    const r = await get(`/api/avatar/${encodeURIComponent(avatarId)}/members`);
    return r?.members || [];
}

export async function deleteMember(avatarId, phone) {
    return del(`/api/avatar/${encodeURIComponent(avatarId)}/members/${encodeURIComponent(phone)}`);
}
